// extracted by mini-css-extract-plugin
export default {"Custom_Label":"Label_Custom_Label__99MEC"};